import React from "react";
import Navbar from "../template/templateAdmin/Navbar";
import Footer from "../template/templateAdmin/Footer";

function Home() {
  return (
    <>
      <Navbar />
      <Footer />
    </>
  );
}

export default Home;
